<template>
  <div>
    <!-- Step 1: Endpoint -->
    <div class="api-step-row">
      <div class="link-api-step"><span>1</span></div>
      <div class="api-step-body">
        <label class="api-step-label">{{ $t("sendMeLink") }} :</label>
        <div class="api-endpoint-bar">
          <span :class="['method-badge', 'method-' + (method || 'POST').toLowerCase()]">
            {{ method || 'POST' }}
          </span>
          <p class="api-url-text">{{ link }}</p>
          <span class="api-copy-btn" @click="copyText('copyText1')">
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 1H12.6C14.8402 1 15.9603 1 16.816 1.43597C17.5686 1.81947 18.1805 2.43139 18.564 3.18404C19 4.03969 19 5.15979 19 7.4V14.5M4.2 19H12.3C13.4201 19 13.9802 19 14.408 18.782C14.7843 18.5903 15.0903 18.2843 15.282 17.908C15.5 17.4802 15.5 16.9201 15.5 15.8V7.7C15.5 6.57989 15.5 6.01984 15.282 5.59202C15.0903 5.21569 14.7843 4.90973 14.408 4.71799C13.9802 4.5 13.4201 4.5 12.3 4.5H4.2C3.0799 4.5 2.51984 4.5 2.09202 4.71799C1.71569 4.90973 1.40973 5.21569 1.21799 5.59202C1 6.01984 1 6.57989 1 7.7V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.0799 19 4.2 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <input ref="copyText1" type="hidden" :value="link" />
        </div>
      </div>
    </div>

    <!-- Step 2: Headers -->
    <div class="api-step-row">
      <div class="link-api-step"><span>2</span></div>
      <div class="api-step-body">
        <label class="api-step-label">أدخل التالي في <strong>header</strong> :</label>
        <div class="api-headers-box">
          <div class="api-header-row">
            <span class="header-key">Accept</span>
            <span class="header-sep">:</span>
            <span class="header-value">{{ accept ? accept : 'application/json' }}</span>
            <span class="api-copy-btn" @click="copyText('copyText2')">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5 1H12.6C14.8402 1 15.9603 1 16.816 1.43597C17.5686 1.81947 18.1805 2.43139 18.564 3.18404C19 4.03969 19 5.15979 19 7.4V14.5M4.2 19H12.3C13.4201 19 13.9802 19 14.408 18.782C14.7843 18.5903 15.0903 18.2843 15.282 17.908C15.5 17.4802 15.5 16.9201 15.5 15.8V7.7C15.5 6.57989 15.5 6.01984 15.282 5.59202C15.0903 5.21569 14.7843 4.90973 14.408 4.71799C13.9802 4.5 13.4201 4.5 12.3 4.5H4.2C3.0799 4.5 2.51984 4.5 2.09202 4.71799C1.71569 4.90973 1.40973 5.21569 1.21799 5.59202C1 6.01984 1 6.57989 1 7.7V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.0799 19 4.2 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <input ref="copyText2" type="hidden" :value="'Accept: ' + (accept ? accept : 'application/json')" />
          </div>
          <div class="api-header-divider"></div>
          <div class="api-header-row">
            <span class="header-key">Content-Type</span>
            <span class="header-sep">:</span>
            <span class="header-value">application/json</span>
            <span class="api-copy-btn" @click="copyText('copyText3')">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5 1H12.6C14.8402 1 15.9603 1 16.816 1.43597C17.5686 1.81947 18.1805 2.43139 18.564 3.18404C19 4.03969 19 5.15979 19 7.4V14.5M4.2 19H12.3C13.4201 19 13.9802 19 14.408 18.782C14.7843 18.5903 15.0903 18.2843 15.282 17.908C15.5 17.4802 15.5 16.9201 15.5 15.8V7.7C15.5 6.57989 15.5 6.01984 15.282 5.59202C15.0903 5.21569 14.7843 4.90973 14.408 4.71799C13.9802 4.5 13.4201 4.5 12.3 4.5H4.2C3.0799 4.5 2.51984 4.5 2.09202 4.71799C1.71569 4.90973 1.40973 5.21569 1.21799 5.59202C1 6.01984 1 6.57989 1 7.7V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.0799 19 4.2 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <input ref="copyText3" type="hidden" value="Content-Type:application/json" />
          </div>
        </div>
      </div>
    </div>

    <!-- Success Response -->
    <div class="api-success-block">
      <h4>{{ $t("replayCaseSuccess") }}</h4>
      <div class="api-success-body">
        <svg width="20" height="20" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" rx="8" fill="#3CB95E"/>
          <path d="M25 14.0857V15.0057C24.9988 17.1621 24.3005 19.2604 23.0093 20.9875C21.7182 22.7147 19.9033 23.9782 17.8354 24.5896C15.7674 25.201 13.5573 25.1276 11.5345 24.3803C9.51168 23.633 7.78465 22.2518 6.61096 20.4428C5.43727 18.6338 4.87979 16.4938 5.02168 14.342C5.16356 12.1903 5.99721 10.1421 7.39828 8.5028C8.79935 6.86354 10.6928 5.72111 12.7962 5.24587C14.8996 4.77063 17.1003 4.98806 19.07 5.86572M25 7L15 17.01L12 14.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="api-success-text">{{ success }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import copyText from "@/mixins/helper.js";
export default {
  mixins: [copyText],
  props: {
    link: { type: String },
    success: { type: String },
    method: { type: String },
    accept: { type: String },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_variables.scss";

.api-step-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.link-api-step {
  flex-shrink: 0;
  border: 2px dashed $mainColor1;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    background-color: $mainColor1;
    width: 44px;
    height: 44px;
    border-radius: 50%;
  }
}

.api-step-body {
  flex: 1;
  min-width: 0;
}

.api-step-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: $mainColor1;
  margin-bottom: 6px;
}

/* Endpoint bar */
.api-endpoint-bar {
  display: flex;
  align-items: center;
  gap: 0;
  background: #f8f8f8;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.method-badge {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  padding: 10px 14px;
  letter-spacing: 0.5px;
  font-family: monospace;
  border-left: 1px solid #e8e8e8;

  &.method-get    { background: #e3f2fd; color: #1565c0; }
  &.method-post   { background: #e8f5e9; color: #2e7d32; }
  &.method-put    { background: #fff3e0; color: #e65100; }
  &.method-patch  { background: #f3e5f5; color: #6a1b9a; }
  &.method-delete { background: #ffebee; color: #c62828; }
}

.api-url-text {
  flex: 1;
  padding: 10px 12px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #333;
  word-break: break-all;
  background: transparent;
  border: none;
  min-width: 0;
  text-align: left;
  direction: ltr;
}

.api-copy-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 12px;
  cursor: pointer;
  color: $mainColor1;
  opacity: 0.7;
  transition: opacity 0.2s;
  &:hover { opacity: 1; }
}

/* Headers box */
.api-headers-box {
  background: #f8f8f8;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}

.api-header-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
}

.api-header-divider {
  height: 1px;
  background: #e8e8e8;
}

.header-key {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  font-weight: 700;
  color: $mainColor1;
  flex-shrink: 0;
  min-width: 130px;
}

.header-sep {
  color: #999;
  flex-shrink: 0;
}

.header-value {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #555;
  flex: 1;
}

/* Success block */
.api-success-block {
  margin-top: 4px;
  h4 {
    font-weight: 600;
    color: #000;
    font-size: 0.95rem;
    margin-bottom: 8px;
  }
}

.api-success-body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: rgba(60, 185, 94, 0.12);
  border: 1px solid rgba(60, 185, 94, 0.35);
  border-radius: 8px;
  padding: 10px 14px;
}

.api-success-text {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #333;
  word-break: break-all;
  direction: ltr;
  text-align: left;
  flex: 1;
}
</style>
